module.exports = __webpack_public_path__ + "img/ppt.23fdabca.png";